interface CropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function getCroppedImage(
  imageSrc: string,
  cropArea: CropArea,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";

    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Nie udało się utworzyć kontekstu canvas"));
        return;
      }

      const outputSize = 256;
      canvas.width = outputSize;
      canvas.height = outputSize;

      ctx.drawImage(
        image,
        cropArea.x,
        cropArea.y,
        cropArea.width,
        cropArea.height,
        0,
        0,
        outputSize,
        outputSize,
      );

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Nie udało się utworzyć obrazu"));
          }
        },
        "image/jpeg",
        0.9,
      );
    };

    image.onerror = () => {
      reject(new Error("Nie udało się załadować obrazu"));
    };

    image.src = imageSrc;
  });
}
